export const tabsAccessibleToProspectiveStudents = new Set(["assessment"])
